// External Imports
import { createContext } from 'react';

// Local Variables
const ListViewContext = createContext();

// Module Exports
export { ListViewContext };
